import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EyeFilledSvg from "@ant-design/icons-svg/es/asn/EyeFilled";
import AntdIcon from "../components/AntdIcon";
var EyeFilled = function EyeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EyeFilled.displayName = 'EyeFilled';
}
export default /*#__PURE__*/React.forwardRef(EyeFilled);